export default "__VITE_ASSET__COWKgd1Y__"